// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1wep8";
var _4 = "input-zv9Xq";
var _5 = "value-PWMJg";
var _6 = "placeholder-hs6Pk";
var _7 = "iata-2Xrh_";
var _8 = "city-1Any0";
var _9 = "button-3jRkS";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "input", _5 as "value", _6 as "placeholder", _7 as "iata", _8 as "city", _9 as "button" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "input": _4, "value": _5, "placeholder": _6, "iata": _7, "city": _8, "button": _9 }
